import { AppShell, Box, createStyles } from '@mantine/core';
import { Outlet, useNavigation } from 'react-router';
import { useSidebarShortcuts } from '../../hooks/useSidebarShortcuts';
import { GlobalSearchProvider } from '../GlobalSearch/provider';
import FullWidthLoadingSpinner from '../LoadingSpinner';
import { PropagateMetadataModal } from '../PropagateMetadata';
import Spotlight from '../Spotlight';
import SideBar from './SideBar';

function SecodaAppShellNavigationLoader() {
	const navigation = useNavigation();

	if (navigation.state === 'loading') {
		return <FullWidthLoadingSpinner />;
	}

	return null;
}

const useStyles = createStyles((theme) => ({
	children: {
		height: '100%',
		backgroundColor: theme.other.getColor('surface/app/default'),
	},
}));

function SecodaAppShell() {
	const { classes } = useStyles();

	// Set up keyboard shortcuts for sidebar toggles
	useSidebarShortcuts();

	return (
		<GlobalSearchProvider>
			<AppShell
				navbar={<SideBar />}
				padding={0}
				navbarOffsetBreakpoint="md"
				asideOffsetBreakpoint="md"
			>
				<PropagateMetadataModal />
				<Box className={classes.children}>
					<SecodaAppShellNavigationLoader />
					<Outlet />
				</Box>
				<Spotlight />
			</AppShell>
		</GlobalSearchProvider>
	);
}

export default SecodaAppShell;
